<template>
  <div class="simple-editor">
    <div id="toolbar">
      <div class="ql-formats">
        <select class="ql-header">
          <option value="1">Heading 1</option>
          <option value="2">Heading 2</option>
          <option selected>Normal</option>
        </select>
      </div>

      <div class="ql-formats">
        <select class="ql-font">
          <option value="serif">Serif</option>
          <option selected>Sans Serif</option>
        </select>
      </div>

      <div class="ql-formats">
        <button class="ql-bold"></button>
        <button class="ql-italic"></button>
        <button class="ql-underline"></button>
      </div>

      <div class="ql-formats">
        <button type="button" class="ql-background" value="rgb(33, 255, 255)"></button>
        <button type="button" class="ql-background" value="rgb(35, 255, 6)"></button>
        <button type="button" class="ql-background" value="rgb(255, 255, 11)"></button>
      </div>

      <div class="ql-formats">
        <button type="button" @click="quillAddDivided">
          <b-icon-file-break></b-icon-file-break>
        </button>
      </div>

      <div class="ql-formats">
        <button type="button" @click="format">
          <b-icon-file-break></b-icon-file-break>
        </button>
      </div>
    </div>
    <div class="editor-node" ref="editorNode"></div>
  </div>
</template>

<script>
  import format from '../utils/formatter'
  import Quill from 'quill'

  let BlockEmbed = Quill.import('blots/block/embed');

  class DividerBlot extends BlockEmbed { }
  DividerBlot.blotName = 'divider';
  DividerBlot.tagName = 'hr';

  Quill.register(DividerBlot);

  export default {
    props: {
      value: {
        default: '',
        type: String
      }
    },

    data () {
      return {
        editorContent: null,
        editorInstance: null,
        editorOpts: {
          modules: {
            toolbar: {
              container: '#toolbar'
            }
          },
          theme: 'snow'
        }
      }
    },

    watch: {
      value (newVal) {
        // Only update the content if it's changed from an external source
        // or else it'll act weird when you try to type anything
        if (newVal !== this.editorContent) {
          this.editorInstance.pasteHTML(newVal)
        }
      }
    },

    mounted () {
      this.initializeEditor()
    },

    beforeDestroy () {
      // Turn off all listeners set on text-change
      this.editorInstance.off('text-change')
    },

    methods: {
      format() {
        this.value = format(this.value)
      },

      quillAddDivided() {
        let quill = this.editorInstance;
        let range = quill.getSelection(true);
        quill.insertText(range.index, '\n', Quill.sources.USER);
        quill.insertEmbed(range.index + 1, 'divider', true, Quill.sources.USER);
        quill.setSelection(range.index + 2, Quill.sources.SILENT);
      },

      initializeEditor () {
        // Set initial content that's going to be picked up by Quill
        this.$refs.editorNode.innerHTML = this.value
        // Create the Quill instance
        this.editorInstance = new Quill(this.$refs.editorNode, this.editorOpts)
        // Setup handler for whenever things change inside Quill
        this.editorInstance.on('text-change', this.onEditorContentChange)
        // Save any initial content to this.editorContent
        this.setEditorContent()
      },
      onEditorContentChange () {
        // Whenever we change anything, update this.editorContent
        this.setEditorContent()
        // Then emit its value as input so we have a working v-model
        // This $emit will be catched up in the watch:value
        // that's why we guard against calling pasteHTML
        // calling that function while we are typing is undesirable
        this.$emit('input', this.editorContent)
      },
      setEditorContent () {
        this.editorContent = this.editorInstance.getText().trim()
          ? this.editorInstance.root.innerHTML
          : ''
      }
    }
  }
</script>

<style>
  .simple-editor {
    height: 100%;
    padding-bottom: 44px;
  }

  .simple-editor .ql-background .ql-fill {
    fill: #fff;
  }

  .simple-editor .ql-background .ql-stroke {
    stroke: #fff;
  }

  .simple-editor .ql-background:first-child {
    background: #37b2d0c9;
  }

  .simple-editor .ql-background:first-child + .ql-background {
    background: #2cca82c9;
  }

  .simple-editor .ql-background:last-child {
    background: #cbd016b0;
  }

  .simple-editor .ql-formats:last-child {
    float: right;
  }

  .ql-editor p {
    margin-bottom: 0.5rem;
  }
</style>